export const defaultSearchValues = {
  employeeName: null,
  document: null,
  documentType: null,
  initContractDate: null,
  endDate: null,
  contractType: null,
  status: null,
  regional:null
};

export const defaultValues = {
  date: null,
  observations: null,
};

export const defaultValuesCost = {
  const: null,
};
